import React from "react";

import Navbar from "../Navbar";
import Footer from "../footer";
import ScrollBack from "../ScrollBack";
import RequestPopUp from "../demo-popup";
import NavScrollBack from "../NavScrollBack";

export default function SiteLayout({ children }) {
  return (
    <div className="min-h-screen bg-white">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-xl focus:bg-white focus:px-4 focus:py-2 focus:shadow-soft"
      >
        Skip to content
      </a>

      <Navbar />

      {/* Global helpers */}
      <ScrollBack />
      <RequestPopUp />
      <NavScrollBack />

      <main id="main" className="pt-20">
        {children}
      </main>

      <Footer />
    </div>
  );
}

